var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_172_1768)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.5 11.25V0H7.5V11.25H0V24.375H30V11.25H22.5ZM13.125 22.5H1.875V13.125H5.625V15H9.375V13.125H13.125V22.5ZM9.375 11.25V1.875H13.125V3.75H16.875V1.875H20.625V11.25H9.375ZM28.125 22.5H16.875V13.125H20.625V15H24.375V13.125H28.125V22.5Z",
    fill: "#77A251"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 30H5.625V28.125H24.375V30H30V26.25H0V30Z",
    fill: "#77A251"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_172_1768"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStock);
export default __webpack_public_path__ + "static/media/stock.603028fa5394732ce88b8450a17139cc.svg";
export { ForwardRef as ReactComponent };